/**
  * Input-Aufgabe: Abfragen eines Textes/einer Zahl in einem Eingabefeld
  * @namespace v3sWbtPlayerApp:exercise:input
  */

/**
 * Definiert die v3s-input Direktive für die Input-Aufgabe. <br>
 * Die Direktive stellt das Input-Element dar und zeigt den Auswertungsstatus an. <br>
 * Die Auswertung wird von dem {@link v3sWbtPlayerApp:exercise:input.service_v3sInputElement} übernommen.
 * @class directive_v3sInput
 * @memberOf v3sWbtPlayerApp:exercise:input
 * @param {number} v3s-size=0 - Größe des Eingabefeldes
 * @param {string} v3s-type=text - Typ des Eingabefeldes (text, number)
 * @param {number} v3s-tolerance=100 - Genauigkeit der Eingabe, 0% - 100% (wird nur bei einem Text beachtet)
 * @param {string} v3s-initvalue - Initialisierungstext
 * @param {(string|number)} v3s-correct - Gesuchte Antwort
 * @param {(string|number)} v3s-alternative - Alternative Antwort
 * @param {string} v3s-fod - Tooltip-Feeback in der Endauswertung
 * @example
 * <v3s-input id="I01" v3s-name="block" v3s-left="599" v3s-top="272" v3s-type="text" 
 *            v3s-visibility="block" v3s-size="10" v3s-tolerance="100">
 *  <v3s-initvalue>5*2x+1x=</v3s-initvalue>
 *  <v3s-correct>elf x</v3s-correct>
 *  <v3s-alternative>11x</v3s-alternative>
 *  <v3s-alternative>11*x</v3s-alternative>
 *  <v3s-fod>x ist eine Unbekannte</v3s-fod>
 * </v3s-input>
 */
angular.module('v3sWbtPlayerApp').directive('v3sInput', ["$tooltip", "v3sInputElement", "v3sI18nService", "v3sCalculatorService", function ($tooltip, v3sInputElement, v3sI18nService, v3sCalculatorService) {
    return {
        restrict: 'EA',
        require: '^v3sDocument',
        scope: {
            id: '@',
            v3sSize: '@',
            v3sType: '@',
            v3sTolerance: '@'
        },
        transclude: true,
        templateUrl: "app/js/exercise/input/input.tpl.html",
        controller: ["$scope", "$element", function ($scope, $element) {
            // Initialisiert die Wert; notwendig für die GAP-Aufgabe, da nicht alle Werte gesetzt werden.
            $scope.id = $scope.id || "";
            $scope.answer = "";
            $scope.placeholder = $scope.placeholder || "";
            $scope.v3sSize = $scope.v3sSize || 0;
            $scope.v3sType = $scope.v3sType || 'text';
        }],
        link: function (scope, element, attributes, v3sDocumentCtrl, transclude) {

            var tooltip, fod;

            scope.getVar = v3sDocumentCtrl.getVar;

            // Ermöglicht Auswahl im WBT-Reviewer
            if (!!scope.id) {
                v3sDocumentCtrl.addElement(element);
            }

            // Model für Auswertung erstellen und mit den Daten versorgen
            var inputElement = new v3sInputElement(scope.id);
            scope.answer = inputElement.getUserAnswer();

            transclude(scope, function (clone, scope) {
                angular.forEach(clone, function (node) {
                    var tagName = node.tagName.toLowerCase();
                    var innerText = node.textContent;
                    if (!!innerText) {
                        if (tagName == "v3s-initvalue") {
                            scope.placeholder = innerText;
                        } else if (tagName == "v3s-correct") {
                            scope.v3sSize = scope.v3sSize ? scope.v3sSize : innerText.length;
                            scope.defaultAnswer = innerText;
                            inputElement.addCorrectAnswer(innerText);
                        } else if (tagName == "v3s-alternative") {
                            inputElement.addCorrectAnswer(innerText);
                        } else if (tagName == "v3s-fod") {
                            fod = innerText;
                        }
                    }
                });
            });

            var tolerance = parseFloat(scope.v3sTolerance) / 100 || 1;
            inputElement.setTolerance(tolerance);
            inputElement.setType(scope.v3sType);


            // Zeigt den Tooltip-Feedback an
            inputElement.setShowFeedback(function () {

                var input = element.find("input");

                if (inputElement.isFeedbackVisible()) {                  
                    var status = inputElement.getStatus();
                    var msg = v3sI18nService.getText([
                        "exercises.fod.input." + status.name,
                        "exercises.fod.general." + status.name
                    ]);

                    if (status == inputElement.STATUS.CORRECT) {
                        element.addClass('correct');
                        input.attr('readonly', 'readonly');
                    } else {
                        if (inputElement.completed) { // Endauswertung
                            if (!!fod) { // FOD angezeigen
                                msg += " " + fod;
                            } else {
                                msg += " " + v3sI18nService.getText('exercises.fod.general.correct_answer_is', { solution: scope.defaultAnswer });
                            }
                        }
                        element.addClass('wrong');
                    }

                    tooltip = $tooltip(element.find("input"), { title: msg, container: "v3s-document", viewport: '#page-view', placement: 'top auto' });
                }

                if (inputElement.completed) {
                    input.attr('readonly', 'readonly');
                }


            });

            // Entfernt den Tooltip, wenn Benutzer die Eingabe ändert
            scope.$watch('answer', function (newAnswer, oldAnswer) {
                if (newAnswer !== oldAnswer) {
                    if (!!tooltip) {
                        tooltip.hide();
                        tooltip.setEnabled(false);
                        element.removeClass('wrong');
                    }
                }
            });

            // Aktualisiert das Model, wenn Benutzer die Eingabe beendet (Verlassen des Feldes, Enter)
            element.find("input").bind('blur', function (event) {
                inputElement.setUserAnswer(scope.answer);
            });

            angular.element(element[0].querySelector("i")).bind('mouseup', function (event) {
                v3sCalculatorService.show(element.attr('id'), updateInputFromCalc);
                event.stopPropagation();
                event.preventDefault();
            });

            function updateInputFromCalc(val, isLastUpdate) {
                scope.answer = val.toString();
                if (isLastUpdate) {
                    inputElement.setUserAnswer(scope.answer);
                }
            }

            // Bei Enter wird die Eingabe beendet
            element.bind('keydown', function (event) {
                var code = event.keyCode || event.which;
                if (code === 13) {
                    element.find("input")[0].blur();
                }
            });
        }
    }
}]);